import React from 'react'
import styled from "styled-components";
import {Button} from "../../assets/ui";
import {width} from "styled-system";

export const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.colors.mainPink};
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  padding: 12px 36px;
  border-radius: 32px;
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
  justify-content: center;

  svg {
    margin-right: 26px;
  }

  @media (max-width: ${({ theme }) => theme.queries.sm}) {
    ${width};
  }
`;

export default Button
